// The AI Agent editor's dialogs and activity feed (components/AIAgent), merged into
// the main dictionary under `editor`: t('editor.<key>'). Same keys in en, es and pt.
import rve from './rve/es.js';
export default {
  // The video editor (components/Editor)
  rve,
  common: {
    cancel: 'Cancelar',
    scene: 'Escena {n}',
    sceneSlide: 'Escena {scene} • Diapositiva {slide}',
    chars: '{n} caracteres',
    unlimited: 'Ilimitado',
    left: 'Quedan {remaining} de {limit}',
    inPro: 'Incluido en Pro',
    premiumFeature: 'Función premium',
    limitReached: 'Límite alcanzado',
    upgradePlan: 'Mejorar plan',
    updateFailed: 'No se pudo actualizar',
    uploadFailed: 'No se pudo subir',
    generationFailed: 'No se pudo generar',
    unexpectedError: 'Ocurrió un error inesperado.',
    fileUploaded: 'El archivo se subió correctamente.',
    pexelsImage: 'Imagen de Pexels seleccionada.',
    pexelsVideo: 'Video de Pexels seleccionado.',
    voiceSelection: 'Selección de voz',
    regenerateAudio: 'Regenerar audio',
    narrationPlaceholder: 'Escribe el texto de la narración...',
    narrationUpdated: 'Narración actualizada',
    audioRegenerated: 'El audio se regeneró correctamente.',
    captionsUpdated: 'Subtítulos actualizados',
    updateCaptions: 'Actualizar subtítulos',
    editCaptions: 'Editar subtítulos',
    mediaLibrary: 'Biblioteca de medios',
    mediaLibraryHint: 'Busca en Pexels o sube tus propios archivos.',
    aiTools: 'Herramientas de IA',
    generateImage: 'Generar imagen',
    generateImageHint: 'Describe lo que imaginas y nuestra IA lo creará desde cero.',
    prompt: 'Descripción',
    promptPlaceholder: 'Una toma cinematográfica de una ciudad futurista al atardecer...',
    generate: 'Generar',
    uploadingAsset: 'Subiendo archivo...',
    generatingImage: 'Generando imagen...',
  },

  premium: {
    title: 'Desbloquea las funciones del Estudio',
    body: 'La generación, la edición y la animación con IA están disponibles en nuestros planes premium.',
    viewPricing: 'Ver precios',
  },

  activity: {
    phases: {
      planning: 'Planificación',
      concept: 'Desarrollo del concepto',
      storyboard: 'Storyboard e investigación',
      writing: 'Redacción del guion',
      voiceover: 'Generación de voz',
      visuals: 'Generación de visuales',
      transcription: 'Transcripción',
      upload: 'Subida a la nube',
      finalizing: 'Finalización',
    },
    creating: 'Creando tu video...',
    complete: '¡Generación completada!',
    remaining: 'Quedan ~{time}',
    almostDone: 'Ya casi…',
    processing: 'Procesando...',
    messages: {
      gettingStarted: 'Comenzando',
      ready: 'Listo',
      conceptReady: 'Concepto listo',
      footageSelected: 'Material seleccionado',
      finalizingScript: 'Finalizando el guion',
      scriptReady: 'Guion listo',
      voiceovers: 'Generando la narración de {n} escenas',
      voiceoversOne: 'Generando la narración de {n} escena',
      allVoiceoversReady: 'Todas las narraciones listas',
      allVisualsReady: 'Todos los visuales listos',
      visualsReady: 'Los {n} visuales están listos',
      visualsReadyOne: '{n} visual listo',
      transcribing: 'Transcribiendo {n} pistas de audio',
      transcribingOne: 'Transcribiendo {n} pista de audio',
      transcribed: '{n} pistas transcritas',
      transcribedOne: '{n} pista transcrita',
      uploadingAssets: 'Subiendo archivos',
      scenesUploaded: '{n} escenas subidas',
      scenesUploadedOne: '{n} escena subida',
      sceneUploaded: 'Escena {n}/{total} subida',
      wrappingUp: 'Últimos retoques',
      videoReady: 'Tu video está listo',
      failed: 'Error: {reason}',
      sceneNarration: 'Escena {n}: "{text}"',
      writingScript: 'Escribiendo el guion de tu video',
      voiceoversAndVisuals: 'Generando la narración y los visuales',
      transcribingAudio: 'Transcribiendo el audio',
      finalizingVideo: 'Finalizando tu video',
      calculatingDuration: 'Calculando la duración del video',
      voiceoversComplete: 'Narración lista, generando los visuales',
      sceneVisualsReady: 'Visuales de la escena {n} listos',
      analyzingIdea: 'Analizando tu idea',
      ideaExpanded: '¡Idea desarrollada! Creando la estructura del video',
      polishingScript: 'Puliendo y finalizando el guion',
      scriptComplete: '¡Guion terminado! Preparando las escenas',
      searchingFootage: 'Buscando material que encaje',
      findingClips: 'Buscando los mejores clips para tu video',
      curatingVisuals: 'Seleccionando visuales adicionales',
      selectingFootage: 'Eligiendo el mejor material para cada escena',
      scriptAndFootageReady: 'Guion y material listos',
      transcriptionComplete: 'Transcripción lista',
      allAssetsUploaded: 'Todos los archivos subidos',
      sceneLabel: 'Escena {n}',
      sceneVoiced: 'Escena {n} narrada',
    },
  },

  addSlide: {
    dialogTitle: 'Agregar diapositiva a la escena {n}',
    title: 'Agregar diapositiva',
    added: 'Diapositiva agregada',
    addFailed: 'Error al agregar la diapositiva',
    addFailedBody: 'No pudimos agregar la diapositiva.',
    uploaded: 'Diapositiva subida',
    generated: 'Diapositiva generada',
    generatedBody: 'Se creó una nueva diapositiva con IA.',
    limitBody: 'Alcanzaste el límite de diapositivas generadas para este proyecto.',
  },

  asset: {
    dialogTitle: 'Editar diapositiva - Escena {scene}, diapositiva {slide}',
    studio: 'Estudio',
    editSlide: 'Editar diapositiva',
    invalidDuration: 'Duración no válida',
    invalidDurationBody: 'Debe ser un número positivo.',
    durationUpdated: 'Duración actualizada',
    durationSet: 'Ahora dura {n} s.',
    durationReset: 'Duración restablecida',
    durationResetBody: 'Ahora se calcula automáticamente.',
    replaced: 'Recurso reemplazado',
    replaceFailed: 'No se pudo reemplazar',
    replaceFailedBody: 'No pudimos reemplazar el recurso.',
    uploaded: 'Recurso subido',
    regenerated: 'Diapositiva regenerada',
    regeneratedBody: 'Se creó una nueva imagen.',
    regenerateLimit: 'Alcanzaste el límite de regeneraciones para este proyecto.',
    edited: 'Diapositiva editada',
    editedBody: 'La imagen se actualizó correctamente.',
    editLimit: 'Alcanzaste el límite de ediciones para este proyecto.',
    editFailed: 'No se pudo editar',
    animateLimit: 'Alcanzaste el límite de animaciones para este proyecto.',
    animationFailed: 'No se pudo animar',
    editImage: 'Editar imagen',
    animateVideo: 'Animar en video',
    editImageHint: 'Modifica la diapositiva actual con instrucciones en lenguaje natural.',
    previewAlt: 'Vista previa de la diapositiva actual',
    editingNote: 'Estás editando la imagen actual de la diapositiva. La IA conservará la composición siempre que pueda.',
    editInstructions: 'Instrucciones de edición',
    editPlaceholder: 'Hazlo de noche, agrega lluvia, cambia el color del auto...',
    applyEdits: 'Aplicar cambios',
    animateTitle: 'Animar esta diapositiva',
    animateHint: 'Convierte la imagen en un clip de 5 segundos con movimiento que se reproduce en su lugar.',
    animate: 'Animar',
    currentAsset: 'Recurso actual',
    assetAlt: 'Recurso actual de la diapositiva',
    badgeVideo: 'VIDEO',
    badgeImage: 'IMAGEN',
    screenTime: 'Tiempo en pantalla',
    auto: 'Auto',
    seconds: 'seg',
    set: 'Aplicar',
    autoSyncing: 'Se sincroniza automáticamente con la narración ({n} s).',
    details: 'Detalles',
    resolution: 'Resolución',
    ratio: 'Proporción',
    enhancingImage: 'Mejorando imagen...',
    animatingVideo: 'Animando tu diapositiva…',
    animatingWait: '{n} s · suele tardar entre 15 y 40 segundos',
    animateAgain: 'Animar de nuevo',
    animateAgainTitle: 'Animar de nuevo',
    stillNote: 'Esta imagen será el primer cuadro del clip. Después puedes volver a ella.',
    animatedNote: 'Esta diapositiva está animada. Prueba otro movimiento desde su imagen o vuelve a la imagen.',
    backToPicture: 'Volver a la imagen',
    animateTime: 'Tarda entre 15 y 40 segundos.',
    animated: 'Diapositiva animada',
    animatedBody: 'Ya se reproduce en tu video. ¿No te convence? Prueba otro movimiento o vuelve a la imagen.',
    restored: 'Volviste a la imagen',
    restoreFailed: 'No se pudo volver a la imagen',
    restoring: 'Volviendo a la imagen…',
  },

  animateAll: {
    animating: 'Animando diapositivas',
    complete: 'Diapositivas animadas',
    stopped: 'Detenido',
    noneWorked: 'No se pudieron animar las diapositivas',
    keepsGoing: 'Puedes cerrar esto: sigue trabajando y cada diapositiva cambia en tu video en cuanto está lista.',
    inProject: 'Los clips nuevos ya están en tu video. Abre una diapositiva para probar otro movimiento o volver a su imagen.',
    progress: '{current} de {total} animadas',
    leftSeconds: 'quedan unos {n} s',
    leftMinutes: 'quedan unos {n} min',
    failed: '{n} no funcionaron',
    stop: 'Detener',
    stopping: 'Se detiene después de esta…',
    hide: 'Ocultar',
    retry: 'Reintentar {n}',
    done: 'Listo',
  },

  voiceConfirm: {

    paidOnly: 'Cambiar la voz de un video terminado es de los planes de pago. Puedes elegir cualquier voz antes de generar el próximo.',

    seePlans: 'Ver planes',
    seconds: '~{n} segundos',
    minuteOne: '~{n} minuto',
    minuteMany: '~{n} minutos',
    title: '¿Cambiar la voz de todas las escenas?',
    description: 'Se regenerará el audio de todas las escenas con la nueva voz.',
    change: 'Cambio de voz:',
    impactOne: 'Se regenerará el audio de {n} escena',
    impactMany: 'Se regenerará el audio de {n} escenas',
    creditsOne: 'Usa {n} crédito de regeneración de voz',
    creditsMany: 'Usa {n} créditos de regeneración de voz',
    time: 'Tiempo estimado: {time}',
    canLeave: 'Se hace en nuestros servidores: puedes cerrar la página',
    canUndo: 'Después puedes volver a la voz actual, sin costo',
    currentUsage: 'Uso actual:',
    afterChange: 'Después de este cambio:',
    remaining: 'Quedan {n}',
    confirm: 'Confirmar y regenerar',
  },

  narration: {
    dialogTitle: 'Editar narración - Escena {n}',
    title: 'Editar narración',
    script: 'Guion',
    hint: 'Edita el texto de abajo para regenerar la narración.',
  },

  scene: {
    dialogTitle: 'Editor de escena - Escena {n}',
    title: 'Editor de escena',
    narrationTab: 'Narración y audio',
    mobileTitle: 'Editar escena {n}',
    script: 'Guion de la narración',
    hint: 'Edita el texto para regenerar la narración con IA.',
    voiceLimit: 'Alcanzaste el límite de regeneraciones de voz para este proyecto.',
    captionsBody: 'Los tiempos se ajustaron automáticamente.',
    timingTitle: 'Tiempos de los subtítulos',
    timingHint: 'Corrige errores de transcripción. Los tiempos se sincronizan solos.',
    timingWarning: 'Estos cambios afectan cómo se ven los subtítulos. Para mejores resultados, mantén la misma cantidad de palabras.',
  },

  motion: {
    // How an animated slide moves (components/AIAgent/MotionPicker.jsx)
    label: '¿Cómo quieres que se mueva?',
    picture: 'Según la imagen',
    pictureHint: 'Se mueve como se describió la imagen',
    subtle: 'Movimiento sutil',
    subtleHint: 'La imagen cobra vida y la cámara no se mueve',
    zoom: 'Zoom lento',
    zoomHint: 'La cámara se acerca despacio al protagonista',
    subject: 'El sujeto se mueve',
    subjectHint: 'Personas y animales respiran, parpadean y gesticulan',
    dramatic: 'Dramático',
    dramaticHint: 'Un gran movimiento de cámara y mucha acción',
    custom: 'Descríbelo tú',
    customHint: 'Cuéntalo con tus palabras',
    customPlaceholder: 'Ej.: cae nieve suave mientras parpadea el farol',
  },

  slides: {
    title: 'Animar diapositivas',
    subtitle: 'Elige las imágenes que quieres convertir en clips cortos con movimiento. Cada una tarda unos 20 segundos.',
    pick: 'Imágenes para animar',
    picked: '{selected} de {total} elegidas',
    selectAll: 'Elegir todas',
    clear: 'Quitar selección',
    left: 'Te quedan {remaining} de {limit} animaciones en este proyecto',
    noneLeft: 'Ya usaste todas las animaciones de este proyecto.',
    upgrade: 'Mejorar plan',
    allMoving: 'Todas las diapositivas de este video ya se mueven.',
    movingOne: '{n} diapositiva ya se mueve (un clip de video o una animación), así que no aparece.',
    movingMany: '{n} diapositivas ya se mueven (clips de video o animaciones), así que no aparecen.',
    underMinute: 'Menos de un minuto',
    aboutMinutes: 'Unos {n} min',
    pickFirst: 'Elige diapositivas',
    animateOne: 'Animar {n} diapositiva',
    animateMany: 'Animar {n} diapositivas',
    thumbAlt: 'Escena {scene} - Diapositiva {slide}',
  },

  captionsEdit: {
    confirm: 'Hay cambios importantes y los tiempos podrían verse afectados. ¿Quieres continuar?',
    updatedBody: 'Los tiempos se ajustaron automáticamente.',
    dialogTitle: 'Editar subtítulos - Escena {n}',
    subtitle: 'Escena {n} • Se sincroniza con el audio',
    warning: 'Al editar el texto, los tiempos de los subtítulos se reajustan automáticamente. Intenta mantener una cantidad de palabras parecida para conservar el ritmo.',
    placeholder: 'Escribe el texto de los subtítulos...',
    words: '{n} palabras',
    autoSync: 'Sincronización automática activada',
  },

  voicePicker: {
    title: 'Elige la voz del narrador',
    description: 'Elige una voz para la narración de tu video',
    confirm: 'Confirmar',
  },

  captionStyle: {
    previewYour: 'Tu',
    previewStory: 'historia',
    templates: {
      keyword: 'Palabra clave',
      minimal: 'Minimal',
      neon: 'Neón',
      tiktok: 'TikTok',
      comic: 'Cómic',
      elegant: 'Elegante',
      glitch: 'Glitch',
      bold: 'Negrita',
      clean: 'Limpio',
      outline: 'Contorno',
      punch: 'Impacto',
      redbox: 'Caja roja',
      boxed: 'En caja',
      podcast: 'Pódcast',
      pop: 'Pop',
      mint: 'Menta',
    },
    position: 'Posición',
    fontText: 'Fuente y texto',
    colors: 'Colores',
    text: 'Texto',
    highlight: 'Resaltado',
    stroke: 'Contorno',
    background: 'Fondo',
    animationTiming: 'Animación y ritmo',
    speed: 'Ritmo',
    speedAria: 'Velocidad de agrupación de palabras',
    words: 'Palabras',
    wordsAria: 'Máximo de palabras por página',
    spacing: 'Espaciado',
    lineHeight: 'Interlineado',
    letterSpacing: 'Entre letras',
    transforms: 'Transformaciones',
    rotation: 'Rotación',
    skew: 'Inclinación',
    scale: 'Escala',
  },

  // El buscador de Pexels y la subida de archivos de los diálogos de escena
  mediaPicker: {
    searchTab: 'Buscar en Pexels',
    uploadTab: 'Subir un archivo',
    images: 'Imágenes',
    videos: 'Videos',
    searchImages: 'Buscar imágenes…',
    searchVideos: 'Buscar videos…',
    search: 'Buscar',
    orientation: 'Orientación',
    anyOrientation: 'Cualquier orientación',
    landscape: 'Horizontal',
    portrait: 'Vertical',
    square: 'Cuadrada',
    size: 'Tamaño',
    anySize: 'Cualquier tamaño',
    small: 'Pequeño',
    medium: 'Mediano',
    large: 'Grande',
    foundImages: '{count} imágenes encontradas',
    foundVideos: '{count} videos encontrados',
    page: 'Página {page}',
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
    promptImagesTitle: 'Busca imágenes',
    promptVideosTitle: 'Busca videos',
    promptImagesBody: 'Escribe arriba lo que necesitas para encontrar imágenes gratis en Pexels.',
    promptVideosBody: 'Escribe arriba lo que necesitas para encontrar videos gratis en Pexels.',
    noImages: 'No hay imágenes para «{query}»',
    noVideos: 'No hay videos para «{query}»',
    select: 'Elegir',
    photoBy: 'Foto de {name}',
    videoBy: 'Video de {name}',
    by: 'de {name}',
    poweredBy: 'Con la tecnología de',
    uploadTitle: 'Sube el tuyo',
    uploadImage: 'Elige una imagen de tu dispositivo.',
    uploadVideo: 'Elige un video de tu dispositivo.',
    uploadBoth: 'Elige una imagen o un video de tu dispositivo.',
    chooseFile: 'Elegir archivo',
    previewImage: 'Vista previa de la imagen',
    previewVideo: 'Vista previa del video',
    close: 'Cerrar',
    cancel: 'Cancelar',
    addImage: 'Usar esta imagen',
    addVideo: 'Usar este video',
    loadFailedTitle: 'No pudimos cargar los resultados',
    loadFailedBody: 'Pexels no respondió. Vuelve a intentarlo en un momento.',
    wrongTypeTitle: 'Ese archivo no sirve aquí',
    wrongTypeImage: 'Elige un archivo de imagen.',
    wrongTypeVideo: 'Elige un archivo de video.',
    wrongTypeBoth: 'Elige una imagen o un video.',
  },
};
